import WeekSelector from './WeekSelector'

export default WeekSelector